import {
  BLACK,
  BLUE,
  CYAN,
  D_BLUE,
  D_CYAN, D_GRAY,
  DD_BLUE, DD_GRAY,
  DDD_BLUE, DEEP_PURPLE,
  FADED_BLUE, G_GRAY, GREEN,
  IGS_BLUE,
  L_CYAN,
  L_GRAY,
  LL_GRAY, ORANGE, WHITE
} from 'style/colors'
import Theme from 'style/theme'

const defaultTheme: Theme = {
  backgroundColor: WHITE,
  buttons: {
    primary: {
      background: CYAN,
      border: CYAN,
      fontColor: WHITE,
      hoverBackground: BLUE,
      hoverBorder: D_BLUE
    },
    secondary: {
      background: BLUE,
      border: D_BLUE,
      fontColor: WHITE,
      hoverBackground: DD_BLUE,
      hoverBorder: DDD_BLUE
    },
    tertiary: {
      background: 'transparent',
      border: L_GRAY,
      fontColor: BLACK,
      hoverBackground: WHITE,
      hoverBorder: D_BLUE
    }
  },
  chip: {
    background: LL_GRAY
  },
  font: {

    color: {
      highlight: D_CYAN,
      highlightDark: BLUE,
      light: D_GRAY,
      normal: BLACK
    },
    weight: {
      bold: '700',
      light: '300',
      mediumLight: '400',
      normal: '500'
    }
  },
  main: IGS_BLUE,

  pageMaxWidth: '1210px',

  link: {
    background: 'transparent',
    color: D_CYAN,
    hoverColor: BLUE
  },

  secondary: FADED_BLUE,
  separator: {
    color: G_GRAY
  },

  productColors: {
    electric: ORANGE,
    gas: FADED_BLUE,
    homeWarranty: GREEN,
    smokeDetector: DEEP_PURPLE,
    thermostat: DEEP_PURPLE
  },

  gap: {
    extraLarge: '20px',
    extraSmall: '4px',
    large: '16px',
    medium: '12px',
    small: '8px'
  },

  select: {
    borderColor: L_GRAY
  },

  menu: {
    dark: '',
    light: '',
    main: CYAN,
    secondary: L_CYAN,
    text: WHITE
  },

  dropDownItem: {
    backgroundColor: WHITE,
    borderColor: G_GRAY,
    hoverColor: LL_GRAY,
    textColor: DD_GRAY,
  }
}

export default defaultTheme



// WEBPACK FOOTER //
// ./src/style/defaultTheme.ts